import React from "react";
import { Col, Form, Pagination, Row } from "react-bootstrap";

const TableFooter = ({ range, setPage, page, slice, totalRows, paginatorSize, rowsPerPage, onPageSizeChange, pageSizeOptions }) => {

    const handleNext = () => {
        if (page !== range.length) {
            setPage(page + 1);
        }
    }

    const handlePrev = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    }

    return (
        <Row className="align-items-center mt-2">
            <Col xs="auto">
                {(() => {
                    const first = (page - 1) * rowsPerPage + 1;
                    const last = Math.min(page * rowsPerPage, totalRows.length);
                    const total = totalRows.length.toLocaleString();
                    return `Showing ${first.toLocaleString()} - ${last.toLocaleString()} of ${total}`;
                })()}
            </Col>
            {onPageSizeChange && pageSizeOptions && (
                <Col xs="auto" className="d-flex align-items-center gap-2">
                    <Form.Select
                        size="sm"
                        value={rowsPerPage}
                        onChange={(e) => onPageSizeChange(Number(e.target.value))}
                        aria-label="Results per page"
                        style={{ width: 'auto' }}
                    >
                        {pageSizeOptions.map(n => (
                            <option key={n} value={n}>{n}</option>
                        ))}
                    </Form.Select>
                    <span className="text-nowrap">results per page</span>
                </Col>
            )}
            <Col>
                <Pagination size={paginatorSize} className='custom-pagination pagination-simple d-flex justify-content-end'>
                    <Pagination.Prev onClick={handlePrev} disabled={page === 1} >
                        <i className="ri-arrow-left-s-line" />
                    </Pagination.Prev>
                    <Pagination.Item active>{page}</Pagination.Item>
                    <Pagination.Next onClick={handleNext} disabled={page === range.length} >
                        <i className="ri-arrow-right-s-line" />
                    </Pagination.Next>
                </Pagination>
            </Col>
        </Row>
    );
};

export default TableFooter;